import { render, staticRenderFns } from "./AddFees.vue?vue&type=template&id=654fe5ad"
import script from "./AddFees.vue?vue&type=script&lang=js"
export * from "./AddFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports